import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import l from '../../../../lang';
import CreateForm from './create-form';
import Loading from '../../../common/loading';
import { initPaymentLink } from '../../../../store/payment-link/actions';
import TopDashboardSection from '../../../common/top-dashboard-section';
import ButtonLink from '../../../common/button-link';
import { Routes } from '../../../../config/routes';
import { useHistory } from 'react-router-dom';
import { ReactComponent as BackIcon } from '../../../../assets/icons/back.svg';
import QuickGuideSteps from '../quick-guide-steps';
import './styles.scss';

const CreatePaymentLink = ({ loading, fnInitPaymentLink }) => {
  const history = useHistory();

  useEffect(() => {
    fnInitPaymentLink();
  }, [fnInitPaymentLink]);

  return (
    <div className="payment-link">
      <QuickGuideSteps />
      <TopDashboardSection
        title={l('paymentLink.title')}
        componentBottom={
          <div className="payment-link__back_btn">
            <ButtonLink
              type="secondary"
              text={
                <>
                  <BackIcon /> {l('paymentLink.backBtn')}
                </>
              }
              onClick={() => history.push(Routes.CREATED_PAYMENT_LINKS)}
            />
          </div>
        }
      />

      {loading && <Loading fullScreem />}
      <CreateForm />
    </div>
  );
};

CreatePaymentLink.propTypes = {
  loading: PropTypes.bool,
};

const mapStateToProps = state => ({
  loading: state.paymentLink.loading,
});

const mapDispatchToProps = dispatch => ({
  fnInitPaymentLink: () => dispatch(initPaymentLink()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreatePaymentLink);
